import {Injectable} from "@angular/core";
import * as signalR from "@microsoft/signalr";
import {Subject} from "rxjs";
import {environment} from "../../../environments/environment";
import {PaymentResponse} from "../../models/Payment/payment-response";
import {SessionService} from "../session.service";

@Injectable({
    providedIn: "root"
})
export class PaymentHub {
    public hubConnection: signalR.HubConnection;

    public readonly $errorMessageEmitter: Subject<PaymentResponse>;
    public readonly $successMessageEmitter: Subject<PaymentResponse>;
    public readonly $rejectSignalEmitter: Subject<boolean>;

    constructor(private session: SessionService) {
        this.$errorMessageEmitter = new Subject<PaymentResponse>();
        this.$successMessageEmitter = new Subject<PaymentResponse>();
        this.$rejectSignalEmitter = new Subject<boolean>();
    }

    public buildConnection() {
        this.hubConnection = new signalR.HubConnectionBuilder()
            .withUrl(`${environment.backendBaseUrl}/ws-hub`, {
                accessTokenFactory: () => this.session.getAuthToken()
            })
            .withAutomaticReconnect()
            .build();
    }

    public startConnection() {
        this.hubConnection
            .start()
            .then(() => {
                this.registerSignalEvents();
            });
    }

    private registerSignalEvents() {
        this.hubConnection.on("paymentError", (res: PaymentResponse) => {
            this.$errorMessageEmitter.next(res);
            this.hubConnection.stop();
        });

        this.hubConnection.on("paymentRejected", () => {
            this.$rejectSignalEmitter.next(true);
            this.hubConnection.stop();
        });

        this.hubConnection.on("paymentSuccess", (res: PaymentResponse) => {
            this.$successMessageEmitter.next(res);
            this.hubConnection.stop();
        });
    }
}
